module.exports = __webpack_public_path__ + "img/548.88a3d1b7.png";